export default __webpack_public_path__ + "static/serotiny@2x-c95af2633db68d90198432eab22b4f6b.png";